import {
  getGuaranteePreSaveApi,
  getGuaranteePreSaveRefundDetailApi,
  getGuaranteePreSaveTransactionPageApi,
  openGuaranteePreSaveApi
} from '@/api/guarantee-pre-save'

const state = {
  // 保证金预存信息
  guaranteePreSave: {}
}

const mutations = {
  SET_GUARANTEE_PRE_SAVE: (state, info) => {
    state.guaranteePreSave = info
  }
}

const actions = {
  /**
   * 申请开通保证金预存账户
   */
  openGuaranteePreSave({ commit }) {
    return new Promise((resolve, reject) => {
      openGuaranteePreSaveApi()
        .then(res => {
          const subAccountInfo = res.data?.vo || {}
          const _data = {
            bank: '平安银行',
            subAccountName: '江西省精彩纵横采购咨询有限公司',
            ...subAccountInfo
          }
          commit('SET_GUARANTEE_PRE_SAVE', _data)
          resolve(_data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * 获取当前用户的保证金预存信息
   */
  getGuaranteePreSave({ commit }) {
    return new Promise((resolve, reject) => {
      getGuaranteePreSaveApi()
        .then(res => {
          const subAccountInfo = res.data?.vo || {}
          const _data = {
            bank: '平安银行',
            subAccountName: '江西省精彩纵横采购咨询有限公司',
            ...subAccountInfo
          }
          commit('SET_GUARANTEE_PRE_SAVE', _data)
          resolve(_data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  /**
   * 分页查询入账或退款记录
   */
  getGuaranteePreSaveRecord(context, params) {
    return new Promise((resolve, reject) => {
      getGuaranteePreSaveTransactionPageApi(params)
        .then(res => {
          const _data = res.data || {}
          resolve(_data)
        })
        .catch(err => reject(err))
    })
  },

  /**
   * 查询退款明细
   */
  getGuaranteePreSaveRefundDetail(context, params) {
    return new Promise((resolve, reject) => {
      getGuaranteePreSaveRefundDetailApi(params.id)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
